'use client';

import { ReactNode } from 'react';

import { Icon } from 'components/common';
import TooltipUnauthorizedMessage from 'components/complex/tooltip-unauthorized-message/tooltip-unauthorized-message';
import { STypography } from 'components/ui';

import { useAccess } from 'lib/api/user';
import { Permission } from 'lib/constants/role-types';

import { NotificationSeverity } from 'types/models/Notification';

import Heading from '../../ui/typography/Heading';
import { SNavigationItem, SNavigationLink, SNavigationLinkWarningIcon } from './styled';

type SidebarLinkProps = {
  path: string;
  title: string;
  icon?: string | ReactNode;
  iconBadge?: string;
  permission?: Permission;
  hasNotification?: boolean;
  hasWarningIcon?: boolean;
  sub?: boolean;
};

export const SidebarLink = ({
  path,
  title,
  icon,
  iconBadge,
  permission,
  hasNotification,
  sub,
}: SidebarLinkProps) => {
  const { checkPermission } = useAccess();
  const hasPermission = !permission || checkPermission(permission);

  const iconComponent = typeof icon === 'string' ? <Icon icon={icon} badge={iconBadge} /> : icon;
  return (
    <TooltipUnauthorizedMessage hasPermission={hasPermission}>
      <SNavigationItem $sub={sub}>
        <SNavigationLink href={path ?? ''} disabled={!hasPermission}>
          {iconComponent}
          <STypography variant="subtitle2">{title}</STypography>
          {hasNotification && <SNavigationLinkWarningIcon severity={NotificationSeverity.Error} />}
        </SNavigationLink>
      </SNavigationItem>
    </TooltipUnauthorizedMessage>
  );
};
